export default function(props, propName, componentName) {
  if (!/(?:[a-z_]+\.)+[a-z_]+/.test(props[propName])) {
    return new Error(
      'Invalid prop `' + propName + '` supplied to' +
      ' `' + componentName + '`. Invalid translation key. Validation failed.'
    );
  }
}
